import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalWrapper: ({ spacing }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p {
      margin: ${spacing.xs} 0 ${spacing.sm} 0;
    }
  `,
})

export { useStyles }
